export default "__VITE_ASSET__ba91e0d7__"